export default __webpack_public_path__ + "static/media/feedback.75d289ea.svg";